import type { FunctionComponent, PropsWithChildren } from 'react';
import { useCallback } from 'react';

import { Tooltip } from '@trello/nachos/tooltip';

import { CollaboratorsBadgeCustomTooltip } from './CollaboratorsBadgeCustomTooltip';
import { CollaboratorsBadgeTooltipContent } from './CollaboratorsBadgeTooltipContent';

export const CollaboratorsBadgeTooltip: FunctionComponent<
  PropsWithChildren<{
    workspaceId: string;
    onCtaClick?: () => void;
  }>
> = ({ children, workspaceId, onCtaClick }) => {
  const getTooltipContent = useCallback(
    () => (
      <CollaboratorsBadgeTooltipContent
        onCtaClick={onCtaClick}
        workspaceId={workspaceId}
      />
    ),
    [workspaceId, onCtaClick],
  );

  return (
    <Tooltip
      content={getTooltipContent}
      // @ts-expect-error component needs type ForwardRefExoticComponent<TooltipPrimitiveProps>
      component={CollaboratorsBadgeCustomTooltip}
      tag="span"
      position="right-start"
    >
      {children}
    </Tooltip>
  );
};
